import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogRef as MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { HelperService } from 'src/services/helperService';
import { UsersComponent } from '../../users.component';
import { UserManagement } from 'src/services/api-services/api-interfaces/userManagement.interface';
import { APIUserManagamentService } from 'src/services/api-services/api-user-Management';


@Component({
    selector: 'app-change-state-user',
    templateUrl: './change-state-user.dialog.html',
    styleUrls: ['./change-state-user.dialog.sass'],
    standalone: false
})
export class ChangeStateUserDialog implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<UsersComponent>,
    @Inject(MAT_DIALOG_DATA) public user: UserManagement,
    public helperService: HelperService,
    private translate: TranslateService,
    public UserManagamentService:APIUserManagamentService,
  ) { }
  ischange:boolean = false

  ngOnInit(): void {

  }
  OnCancel(){
    this.dialogRef.close();
  }
  OnSave(){
    this.ischange = true
    this.UserManagamentService.patchChangeState(this.user.userId,this.user.isActive).subscribe(
      {
        next: (response: any) => {
          if (response?.code === 200) {
            const translateTextsucces = this.translate.instant(
              "ToastsuccessChangeStateUser",
              { User: this.user.userName }
            );
            this.helperService.showAlert = true;
            this.helperService.typeAlert = "success";
            this.helperService.messageAlert = translateTextsucces;

            setTimeout(() => {
              this.helperService.showAlert = false;
            }, 7000);

            this.dialogRef.close();
          }
        },
        error: (failed) => {
          // Manejo de error 401
          if (failed.status === 401) {
            this.helperService.logoutToken();
          }

          let mensageError = failed.error.text;
          if(mensageError === "{ 'code': '200', 'message': 'Status has been updated.' }"){
            const translateTextsucces = this.translate.instant("ToastsuccessChangeStateUser",{User:this.user.userName});
            this.helperService.showAlert =true
            this.helperService.typeAlert ="success"
            this.helperService.messageAlert =translateTextsucces
            setTimeout(() => {
              this.helperService.showAlert =false

              }, 7000)
            this.dialogRef.close();
          }
          else{
            const translateTextError = this.translate.instant("ToasterrorChangeStateUser",{User:this.user.userName});
            this.helperService.showAlert =true
            this.helperService.typeAlert ="error"
            this.helperService.messageAlert =translateTextError
            setTimeout(() => {
              this.helperService.showAlert =false

            }, 7000)
            this.dialogRef.close();
          }

        },
      }
    )
  }

}
